import * as Bs from '@bootstrap-styled/v4'
import styled from 'styled-components'

export const Label = styled(Bs.Label)`
  font-size: 14px;
`
